import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postSaveVarientSlice = createApi(`PostSaveVarientSlice`,"POST");

const PostSaveVarientSlice = createSlice({
  name: 'PostSaveVarientSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postSaveVarientSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSaveVarientSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postSaveVarientSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostSaveVarientSlice.reducer;